module.exports = __webpack_public_path__ + "media/images/lb/540-4e73b8c4e5e52e15dd864b537c1c16db.svg";